import React from "react"
import PropTypes from "prop-types"
import { logoForShop } from "../../../shared_component/utils/shopLogos"
import { constants } from "caradvise_shared_components"
import { toCurrencyString } from "../../../shared_component/utils/currency"
import GenericPanel from "../GenericPanel"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faCaretRight } from "@fortawesome/free-solid-svg-icons"
import { PRICE } from "./SelectShop"
import SavingsRibbon from "./SavingsRibbon"
import { useTranslation } from "react-i18next"
import { capitalize } from "../../helpers/stringHelpers"
import { getNewTiresServiceFromServices } from "../../helpers/orderServiceHelpers"
import { getPricingInfo } from "../../helpers/shopHelpers"
import DisplayMessage from "./DisplayMessage"
import { MD_HD_VEHICLE_TYPE_ID } from "../../constants/application"

const ShopListItems = ({
  shops,
  onSelect,
  shouldDisplayPrice,
  companiesWithTireSelection,
  orderServices,
  vehicleTypeId
}) => {
  const { t } = useTranslation("shopList")
  return (
    <div className="shopList">
      {shops.map((shop, index) => {
        const src = logoForShop(shop)
        let logo = src !== undefined ? <img style={{ width: "40px" }} src={src} /> : null

        return (
          <div key={`shop-list-item-${shop.id}`} className="shopCard box-shadow">
            <div
              className="selectedShop"
              onClick={() => onSelect(shop.company, shop.featured == true ? shop : null)}
            >
              <div className="selectedShopLogo">{logo}</div>
              <div className="selectedShopInfo">
                {shop && shop.featured && shop.name && (
                  <div className="featuredShopTitle">
                    {shop.company.name ? shop.company.name : shop.name}
                  </div>
                )}
                <div>{t("nearestLocationLbl")}</div>
                <strong>{`${t("milesAwayLbl", {
                  value: shop.distance_config.display_quantity,
                  unit: capitalize(shop.distance_config.units)
                })}`}</strong>
              </div>
              {shouldDisplayPrice && (
                <div className="selectedShopMemberPrice">
                  <div className="asLowAs">
                    {getPricingInfo(
                      !!getNewTiresServiceFromServices(orderServices),
                      companiesWithTireSelection[shop.company.id],
                      shop.shopPriceText,
                      shop.shopPriceEstimate,
                      shop,
                      t,
                      vehicleTypeId
                    )}
                  </div>
                </div>
              )}
              <FontAwesomeIcon icon={faCaretRight} size={"1x"} color={"lightgray"} />
            </div>
            {shop.hasRetailSavings &&
              !shop.cdk_dealer &&
              vehicleTypeId !== MD_HD_VEHICLE_TYPE_ID && (
                <SavingsRibbon
                  savingsText={shop.total_retail_savings}
                  containerStyle={{ marginTop: "-25px", paddingBottom: "10px" }}
                />
              )}
          </div>
        )
      })}
    </div>
  )
}

export const ShopList = ({
  sortedShops,
  onSelect,
  shouldDisplayPrice,
  orderServices,
  vehicleTypeId
}) => {
  const { t } = useTranslation("shopList")
  const numberOfHighlightedShops = 3
  let highlightedShops = []
  let nonHighlightedShops = []
  sortedShops.forEach((shop) => {
    if (shop.featured && highlightedShops.length < numberOfHighlightedShops) {
      highlightedShops.push(shop)
    } else {
      nonHighlightedShops.push(shop)
    }
  })

  const paidIndependent = "paidIndependent"
  const unpaidIndependent = "unpaidIndependent"
  let shopGroups = {}
  let nonHighlightedShopsGrouped = []
  let companiesWithTireSelection = {}
  nonHighlightedShops.forEach((shop) => {
    if (shop.independent && shop.featured) {
      if (shop.supports_tire_selection) {
        companiesWithTireSelection[paidIndependent] = true
      }
      if (!shopGroups[paidIndependent]) {
        shopGroups[paidIndependent] = shop
        nonHighlightedShopsGrouped.push(shop)
      }
    } else if (shop.independent && !shop.featured) {
      if (shop.supports_tire_selection) {
        companiesWithTireSelection[unpaidIndependent] = true
      }
      if (!shopGroups[unpaidIndependent]) {
        shopGroups[unpaidIndependent] = shop
        nonHighlightedShopsGrouped.push(shop)
      }
    } else {
      if (shop.supports_tire_selection) {
        companiesWithTireSelection[shop.company_id] = true
      }
      if (!shopGroups[shop.company_id]) {
        shopGroups[shop.company_id] = shop
        nonHighlightedShopsGrouped.push(shop)
      }
    }
  })

  return (
    <div>
      {highlightedShops && highlightedShops.length > 0 && (
        <div className="featuredShopsContainer">
          <div className="featuredShopsHeader">{t("featuredShopsLbl")}</div>
          <div className="shopList">
            <ShopListItems
              shops={highlightedShops}
              orderServices={orderServices}
              companiesWithTireSelection={companiesWithTireSelection}
              onSelect={onSelect}
              shouldDisplayPrice={shouldDisplayPrice}
              vehicleTypeId={vehicleTypeId}
            />
          </div>
        </div>
      )}

      <DisplayMessage message={t("common:mdHdShopsLabel")} vehicleTypeId={vehicleTypeId} />
      <div className="nonFeaturedShopsContainer">
        <div className="shopList">
          <ShopListItems
            orderServices={orderServices}
            shops={nonHighlightedShopsGrouped}
            companiesWithTireSelection={companiesWithTireSelection}
            onSelect={onSelect}
            shouldDisplayPrice={shouldDisplayPrice}
            vehicleTypeId={vehicleTypeId}
          />
        </div>
      </div>
    </div>
  )
}

ShopList.propTypes = {
  shops: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number.isRequired,
      city: PropTypes.string.isRequired
    })
  ).isRequired,
  shouldDisplayPrice: PropTypes.bool.isRequired,
  onSelect: PropTypes.func.isRequired
}

export default ShopList
